module.exports = __webpack_public_path__ + "img/bills_paper.946afb86.png";